var render = function (_h,_vm) {var _c=_vm._c;return _c('v-select',_vm._b({attrs:{"value":_vm.props.value,"items":_vm.props.values},on:{"input":_vm.listeners.input}},'v-select',_vm.data.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }